import { render, staticRenderFns } from "./IconUpsert.vue?vue&type=template&id=13c3f24e&scoped=true&"
import script from "./IconUpsert.vue?vue&type=script&lang=ts&"
export * from "./IconUpsert.vue?vue&type=script&lang=ts&"
import style0 from "./IconUpsert.vue?vue&type=style&index=0&id=13c3f24e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c3f24e",
  null
  
)

export default component.exports